module.exports = __webpack_public_path__ + "img/google.8b126737.png";